export default __webpack_public_path__ + "static/fb-editorial-women-988d29112af19246bcac90166ef803f3.jpg";